export default {"src":"/_next/static/media/conflictsManagement.3905f740.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};